import { useState } from "react";
import { Check } from "lucide-react";
import { THEMES, applyTheme, getThemeId } from "../lib/theme";

export const ThemeSwitcher = () => {
  const [current, setCurrent] = useState(getThemeId());
  return (
    <div className="flex items-center gap-2" data-testid="theme-switcher">
      <span className="font-mono text-[11px] uppercase tracking-widest text-muted-c mr-1">Theme</span>
      {THEMES.map((t) => (
        <button key={t.id} title={t.name} aria-label={t.name} data-testid={`theme-option-${t.id}`}
          onClick={() => setCurrent(applyTheme(t.id))}
          className={`h-6 w-6 rounded-full border-2 grid place-items-center transition-transform hover:scale-110 ${current === t.id ? "border-ink" : "border-line2"}`}
          style={{ background: t.dark ? `linear-gradient(135deg, #0b0f17 50%, ${t.swatch} 50%)` : "linear-gradient(135deg, #ffffff 50%, #2563eb 50%)" }}>
          {current === t.id && <Check className="h-3 w-3 text-white drop-shadow" />}
        </button>
      ))}
    </div>
  );
};
